import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

const getEnvLabel = () =>
  process.env.NODE_ENV === "production" ? "PROD" : "DEV";

const AppLayout: React.FC = () => {
  return (
    <div className="flex min-h-screen bg-page text-ink">
      <Sidebar />
      <div className="flex flex-1 flex-col">
        <Topbar envLabel={getEnvLabel()} />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
